// extracted by mini-css-extract-plugin
export default {"indicator":"onboarding-step-indicator_indicator__m0Ley","indicator__text":"onboarding-step-indicator_indicator__text__IaHDv"};